/*
  Require an explicit size selection.
  - On load (and on product swap) clears the theme's pre-selected size so no
    size box is highlighted by default.
  - Add to Cart stays clickable, but if the shopper submits with no size chosen
    the add is blocked, the size boxes get an error outline, and a "Please choose
    your size." message is shown below the Add to Cart button.
  Scoped via the [data-size-option] marker on the size fieldset.
*/
(function () {
  if (window.__prmeRequireSize) return;
  window.__prmeRequireSize = true;

  function scopeOf(el) {
    return (el && el.closest && el.closest('product-info')) || document;
  }

  function clearInitialSize(root) {
    // Respect an explicit variant chosen via the URL (?variant=…) — a direct link
    // to a specific size is an intentional choice, so keep it selected.
    try {
      if (new URLSearchParams(window.location.search).has('variant')) return;
    } catch (e) {}
    (root || document).querySelectorAll('[data-size-option]').forEach(function (group) {
      if (group.dataset.sizeCleared === '1') return;
      var checked = group.querySelector('input[type="radio"]:checked');
      if (checked) checked.checked = false;
      group.dataset.sizeCleared = '1';
    });
  }

  function showError(scope) {
    var group = scope.querySelector('[data-size-option]');
    if (!group) return;
    group.classList.add('has-size-error');
    if (scope.querySelector('.size-required-error')) return;
    var el = document.createElement('p');
    el.className = 'size-required-error';
    el.setAttribute('role', 'alert');
    el.textContent = group.getAttribute('data-size-required-text') || 'Please choose your size.';
    var btn = scope.querySelector('[name="add"]');
    var anchor = btn && (btn.closest('.product__submit__buttons') || btn.closest('.product__submit__item'));
    if (anchor && anchor.parentNode) anchor.insertAdjacentElement('afterend', el);
    else group.appendChild(el);
  }

  function clearError(scope) {
    var group = scope.querySelector('[data-size-option]');
    if (group) group.classList.remove('has-size-error');
    scope.querySelectorAll('.size-required-error').forEach(function (e) { e.remove(); });
  }

  // Block add-to-cart submits when no size is selected
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement) || !form.querySelector('[name="add"]')) return;
    var scope = scopeOf(form);
    var group = scope.querySelector('[data-size-option]');
    if (group && !group.querySelector('input[type="radio"]:checked')) {
      e.preventDefault();
      e.stopImmediatePropagation();
      showError(scope);
      group.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }
  }, true);

  // Clear the error as soon as a size is chosen
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('[data-size-option]')) clearError(scopeOf(t));
  });

  document.addEventListener('DOMContentLoaded', function () { clearInitialSize(document); });
  document.addEventListener('theme:product-info:loaded', function (e) {
    clearInitialSize((e && e.target) || document);
  });
  if (document.readyState !== 'loading') clearInitialSize(document);
})();
